import { getField, updateField } from "vuex-map-fields"
import {Api} from "@/plugins/axios"
import Vue from "vue"
import { trackProfileCompleted } from "@/plugins/eventTrigger"
export const state = () => ({
    loading: false,
    profileLoading: false,
    activeComponent: 'profile',
    profileError : null,
    profileImgUrl : '',
    logoImgUrl : '',
    brokerageImgUrl : '',
    // Limit which fields are available to the agent profile page
    adminData: {
        id : '',
        firstname : '',
        lastname : '',
        email : '',
        p_email : '',
        cc_email : '',
        alias : '',
        n_phone : '',
        c_phone : '',
        timezone : '',
        gci : '',
        bio : '',
        gender : '',
        facebook_url : '',
        twitter_url : '',
        linked_in : '',
        youtube_url : '',
        googleplus_url : '',
        instagram_url : '',
        mtls_emails : '',
        license_number : '',
        on_vacation : '',
        company : '',
        mailing_address : '',
        mailing_zip : '',
        mailing_state : '',
        mailing_city : '',
        country : '',
        brokerage_url : '',
        realtor_url : '',
        bbb_url : '',
        yelp_url: '',
        google_place : '',
        personal_url : '',
        other_url : '',
        brokerage_name : '',
        tiktok_url : '',
        brokerage_logo_id : '',
        logo_image_id : '',
        profile_image_id : '',
        domain_alias_id : '',
        username : '',
        email_signature : '',
        add_signature_to_emails : '',
        text_logo : '',
        profile_complete: false,
        task_call_enabled : '',
        task_call_recording : '',
        voicemail : '',
        ai_voicemail : false,
        new_task_notification_method : '',
        default_send_reminder_on : ''
    },
    requiredFields : [
        'firstname', 'lastname', 'p_email', 'n_phone', 'c_phone',
        'timezone', 'country'
    ],
    logos : {

    }
})

export const actions = {
    async getProfile({commit}, adminId){
        commit('profileLoading', true)
        const {
            data: { admin, message, errors },
            status,
        } = await Api.get("/api/v1/admins/view/" + adminId);

        await commit('setAdmin', admin)
        commit('profileLoading', false)
    },
    async checkAliasAvailability({commit, state}){
        commit('loading', true)
        commit('profileError', null)
        try {
            let { data : { available } } = await Api.get('/api/v1/admins/check-alias-availability', { params : { adminId : state.adminData.id, alias : state.adminData.alias } })
            return available;
        } catch (error) {
            commit('loading', false)
            console.error('Error checking alias availability:', error);
            commit('profileError', error)
        }
        commit('loading', false)
    },

    async saveProfile({commit, state}, field = null){
        commit('loading', true)
        commit('profileError', null)
        let fieldsToSave = {}
        
        if (field === null || field === undefined) {
            // all the fields!
            fieldsToSave = state.adminData
        } else if (typeof field === 'string') {
            // a single field
            fieldsToSave[field] = state.adminData[field]
        } else if (Array.isArray(field)) {
            // array of field names
            field.forEach(fieldName => {
                fieldsToSave[fieldName] = state.adminData[fieldName]
            })
        } else if (typeof field === 'object') {
            // fields object directly
            fieldsToSave = field
        }
        try {
            let { data : { admin, success, error } } = await Api.post('/api/v1/admins/update-profile-fields', { id : state.adminData.id, fields : fieldsToSave })
            
            if ( success ){
                commit('setAdmin', admin)
                trackProfileCompleted(state.adminData.id,{
                  domain : state.adminData.domain,
                  platform : state.platform
                })
            } else if (error) {
                commit('profileError', { type: 'validation', message: error })
            }

            commit('loading', false)
        } catch (error) {
            commit('loading', false)
            // Handle backend validation errors
            const errorMessage = error.response?.data?.message || error.message || 'An error occurred while saving your profile.';
            commit('profileError', { type: 'validation', message: errorMessage })
            throw error; // Re-throw to be caught by the component
        }
    }
}

export const getters = {
    getField,
    adminId(state){
        return state.adminData.id
    },
    contactInfoValid(state){
      for ( let i in state.requiredFields ){
          let field = state.requiredFields[i]
          if ( !state.adminData[field] ){
              return false
          }
      }
      return true
    }
}

export const mutations = {
    updateField,
    loading(state, v){
        state.loading = v
    },
    profileLoading(state, v){
        state.profileLoading = v
    },
    setAdmin(state, admin){
        // only set values for the fields defined in the store
        for (let key in state.adminData) {
            if (state.adminData.hasOwnProperty(key)) {
                Vue.set(state.adminData, key, admin[key])
            }
        }
    },
    profileError(state, errorMessage){
        state.profileError = errorMessage ? {
            type: errorMessage.type,
            message: errorMessage.message
        } : null //adding type field to handle more than just alias errors
    },
    updateProfileImgUrl(state, newUrl) {
        state.profileImgUrl = newUrl
    },
    updateLogoImgUrl(state, newUrl) {
        state.logoImgUrl = newUrl
    },
    updateBrokerageImgUrl(state, newUrl) {
        state.brokerageImgUrl = newUrl
    }
}
